// extracted by mini-css-extract-plugin
export var card = "_qi-0";
export var content = "_qi-2";
export var details = "_qi-3";
export var icon = "_qi-1";
export var iconBlue = "_qi-5";
export var iconBrand = "_qi-4";
export var iconGrayBlue = "_qi-6";
export var iconGreen = "_qi-7";
export var iconIndigo = "_qi-8";
export var iconOrange = "_qi-9";
export var iconPurple = "_qi-a";
export var iconRed = "_qi-b";
export var iconWarning = "_qi-c";